/**
 * @license
 *
 * Copyright IBM Corp. 2020, 2022
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */

import '../background-media/index';
import './leadspace-with-search';
import './leadspace-with-search-copy';
import '../search-with-typeahead/index';
import '../horizontal-rule/index';
